<template>
    <v-navigation-drawer
        v-model="show"
        fixed
        right
        stateless
        touchless
        temporary
        width="700"
    >
        <v-layout row wrap fill-width class="pa-1" v-if="Object.values($basket.getLatestAddedItems()).length === 0">
            <v-flex xs11 pt-2 class="body-1 font-weight-bold disabled_grey--text text--darken-2">
                {{ 'Das Produkt wurde aus dem Warenkorb entfernt' | translation }}
            </v-flex>

            <v-flex>
                <v-btn icon @click.stop="show = false">
                    <v-icon>$vuetify.icons.close</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>

        <added-to-basket v-if="show && Object.values($basket.getLatestAddedItems()).length > 0" v-model="show"/>

        <main-content v-else-if="show" v-model="show"></main-content>
    </v-navigation-drawer>
</template>

<script>
    import Basket from '../Basket';
    import {mapState, mapMutations} from 'vuex';
    import MainContent from './MainContent';

    const moduleName = 'FloatingBasket';

    export default {
        name: moduleName,
        extends: Basket,
        props: [
            'value',
        ],
        components: {
            MainContent,
        },
        computed: {
            ...mapState(moduleName, [
                'showFloatingBasket',
            ]),
            show: {
                get() {
                    return this.value !== undefined ? this.value : this.showFloatingBasket;
                },
                set(value) {
                    this.$emit('input', value);
                    this.setShowFloatingBasket(value);

                    if (!value) {
                        this.$vuetify.goTo(0, {});
                    }
                },
            },
        },
        methods: {
            ...mapMutations(moduleName, [
                'setShowFloatingBasket',
            ]),
        },
    };
</script>